import { TextWithIcon } from "./text-with-icon.tsx";
export type { TextWithIconProps } from "./text-with-icon.tsx";

export default TextWithIcon;
